import { useState } from 'react';

import { embryoStageLabel } from '../../../core/constants/transfers';
import { fmtNum } from '../../kpis/utils/format';
import { useLabStats } from '../../stats/contexts/stats';
import StatsView, { StatsFilters } from '../../stats/layouts/entity-stats';

const todayStr = () => new Date().toLocaleDateString('en-CA');
const yearStart = () => `${new Date().getFullYear()}-01-01`;

// Distribución de calidad (estadio) de embriones del lab. `unknown` = sin stage.
function QualityPanel({ data }) {
    const entries = Object.entries(data || {});
    if (!entries.length) return null;
    return (
        <article className="report-card estats-extra">
            <h2 className="report-section__title">Calidad de embriones (estadio)</h2>
            <div className="estats-quality">
                {entries.map(([stage, n]) => (
                    <span key={stage} className="estats-quality__chip">
                        <span className="estats-quality__stage">{stage === 'unknown' ? '—' : embryoStageLabel(stage)}</span>
                        <span className="estats-quality__n">{fmtNum(n)}</span>
                    </span>
                ))}
            </div>
        </article>
    );
}

// Estadísticas de un LABORATORIO (admin-stats.md): throughput (ovocitos→embriones) +
// downstream + distribución de calidad. Filtros: rango por fecha del clivage + cliente/finca.
export default function LabStats({ labId }) {
    const [range, setRange] = useState({ from: yearStart(), to: todayStr() });
    const [scope, setScope] = useState({ client_id: '', farm_id: '' });
    const [active, setActive] = useState(null);

    const pick = (item, type) => {
        if (type === 'farm') { setScope({ client_id: '', farm_id: String(item.id) }); setActive({ type, label: `${item.name}${item.owner?.name ? ` · ${item.owner.name}` : ''}` }); }
        else { setScope({ client_id: String(item.id), farm_id: '' }); setActive({ type, label: item.name }); }
    };
    const clearScope = () => { setScope({ client_id: '', farm_id: '' }); setActive(null); };

    const { data, isLoading, isFetching, error } = useLabStats(labId, { ...range, ...scope });
    const name = data?.entity?.name || `#${labId}`;

    return (
        <StatsView
            data={data} isLoading={isLoading} isFetching={isFetching} error={error}
            title={`Laboratorio · ${name}`}
            subtitle="Volumen y eficiencia del laboratorio."
            backTo={`/admin/labs/${labId}`} backLabel="Volver al laboratorio"
            filters={<StatsFilters range={range} onRange={(p) => setRange((r) => ({ ...r, ...p }))} withScope active={active} onPick={pick} onClear={clearScope} busy={isFetching} />}
        >
            <QualityPanel data={data?.quality} />
        </StatsView>
    );
}
